import { BlueprintStepTemplate } from "../../../models/Blueprints";
import { HeaderPretitle } from "../../shared/text/MergeText";
import TypeaheadFormField from "./TypeaheadFormField";
import JSONSchemaTreeDiagram from "../../shared/JSONSchemaTreeDiagram";

interface Props {
  stepID: string;
  stepTemplate: BlueprintStepTemplate;
}

const BlueprintEditorRightPanelArrayTraversalForm = (props: Props) => {
  return (
    <>
      <HeaderPretitle className="my-2">Parameters</HeaderPretitle>
      <TypeaheadFormField
        key={"key"}
        title={"Array Traversal Key"}
        subtitle={"Key used to fetch the array traversal list."}
        valueKey={"key"}
        parameterType={"string"}
      />
      <HeaderPretitle className="mt-3">Return Values</HeaderPretitle>
      <JSONSchemaTreeDiagram stepID={props.stepID} jsonSchema={props.stepTemplate.return_schema} />
    </>
  );
};

export default BlueprintEditorRightPanelArrayTraversalForm;
